var _ellipse, _rect, _path, _path2, _path3, _g, _path4, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInboxemptystate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 163,
    viewBox: "0 0 110 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.6458,
    cy: 158.47,
    rx: 32.2771,
    ry: 3.92939,
    fill: "#E6EDF5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 99,
    width: 3,
    height: 59,
    fill: "#B6E2D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.7186 108.072C64.257 115.885 54.4727 124.538 56.6771 156.688C80.32 148.252 88.9982 139.109 90.7186 108.072Z",
    fill: "#6DD3B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0651 101.432C22.3293 124.663 28.6368 134.789 55.7365 140.249C54.2658 118.156 47.6077 108.832 18.0651 101.432Z",
    fill: "#6DD3B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6232 20.6229L74.5914 33.8324L89.8999 35.7389L88.582 51.1093L99.8461 61.6498L89.7454 73.31L92.6628 88.4583L77.6375 91.9546L71.0937 105.925L56.8829 99.9215L43.3775 107.377L35.4093 94.1677L20.1008 92.2612L21.4188 76.8908L10.1546 66.3503L20.2553 54.6901L17.3379 39.5418L32.3632 36.0455L38.907 22.0754L53.1178 28.0786L66.6232 20.6229Z",
    fill: "#F8EEC8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_12448_46009)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.0001,
    cy: 64,
    rx: 35.9258,
    ry: 35.9259,
    transform: "rotate(15 55.0001 64)",
    fill: "#FBEA96"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4886 67.1677C63.063 75.6508 47.668 75.0224 38.5566 67.1677",
    stroke: "#F6B276",
    strokeWidth: 1.57093
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5571,
    cy: 67.168,
    rx: 4.0844,
    ry: 4.08445,
    fill: "#F7CE6C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.4887,
    cy: 67.168,
    rx: 4.0844,
    ry: 4.08445,
    fill: "#F7CE6C"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.6109,
    cy: 60.6644,
    rx: 2.82766,
    ry: 2.8277,
    fill: "#324553"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.4351,
    cy: 60.6644,
    rx: 2.82766,
    ry: 2.8277,
    fill: "#324553"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_12448_46009",
    x: 19.0654,
    y: 28.0652,
    width: 71.8696,
    height: 71.8696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.807843 0 0 0 0 0.423529 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12448_46009"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxemptystate);
export default __webpack_public_path__ + "static/media/inboxemptystate.177a0750acdef44c6c7f55fd9d46b980.svg";
export { ForwardRef as ReactComponent };